import { Type } from 'class-transformer';
import { AddContactInfoCustomFieldHeaderResultDto } from './add-contact-info-custom-field-header-result-dto';
import { AddContactInfoRawDto } from './add-contact-info-raw-dto';
import { AddContactTypeResultDto } from './add-contact-type-result-dto';
import { OwnerRegistrationRawDto } from './owner-registration-raw-dto';

export class RegistrationEditorResultDto {
  @Type(() => OwnerRegistrationRawDto)
  owners: Array<OwnerRegistrationRawDto>;

  @Type(() => AddContactTypeResultDto)
  contactTypes: Array<AddContactTypeResultDto>;

  @Type(() => AddContactInfoRawDto)
  phoneData: Array<AddContactInfoRawDto>;

  @Type(() => AddContactInfoCustomFieldHeaderResultDto)
  phoneCustomDataFields: Array<AddContactInfoCustomFieldHeaderResultDto>;

  @Type(() => AddContactInfoRawDto)
  registrationEmailContact: AddContactInfoRawDto;

  @Type(() => AddContactInfoCustomFieldHeaderResultDto)
  emailCustomDataFields: Array<AddContactInfoCustomFieldHeaderResultDto>;

  defaultPhoneSubTypeId: string;
  defaultEmailSubTypeId: string;
}
